export const RELEVANT_FILTER_SECTIONS = ['Business unit', 'Field', 'Method of production', 'Groups'] as const;

const ASSET_GUID_PROPERTY = 'Assetguid';

export const createFilterFunction = (
  hasActiveFilters: boolean,
  filteredAssetList: any[],
  nameProperty = 'WellName',
) => {
  if (!hasActiveFilters) {
    return (data: any[]) => data;
  }

  if (!filteredAssetList?.length) {
    return () => [];
  }

  // For Assetguid property, match against assetId; otherwise match against assetName
  const isAssetGuidProperty = nameProperty === ASSET_GUID_PROPERTY;
  const assetPropertyKey = isAssetGuidProperty ? 'assetId' : 'assetName';

  const filteredAssetValues = new Set(
    filteredAssetList.map((asset: any) => asset[assetPropertyKey]?.toLowerCase()).filter(Boolean),
  );

  return (data: any[]) => {
    if (!Array.isArray(data)) {
      return [];
    }

    return data.filter((item: any) => {
      const itemValue = item?.[nameProperty]?.toLowerCase();
      return itemValue && filteredAssetValues.has(itemValue);
    });
  };
};

export const hasActiveRelevantFilters = (selectedFilters: Array<{ section: string; value: string }>): boolean => {
  if (!Array.isArray(selectedFilters) || selectedFilters.length === 0) {
    return false;
  }

  return selectedFilters.some((filter) => RELEVANT_FILTER_SECTIONS.includes(filter.section as any));
};

export const extractGroupNamesFromFilters = (selectedFilters: Array<{ section: string; value: string }>): string[] => {
  if (!Array.isArray(selectedFilters)) {
    return [];
  }

  return selectedFilters
    .filter((filter) => filter.section === 'Groups')
    .map((filter) => filter.value)
    .filter(Boolean);
};
